import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { AppointmentSetupComponent } from "./appointment-setup/appointment-setup.component";
import { BookingComponent } from "./booking/booking.component";
import { AppointmentsSetupNavComponent } from "./appointments-setup-nav/appointments-setup-nav.component";
import { BookingNavComponent } from "./booking-nav/booking-nav.component";
import { ExitConfirmationComponent } from "./exit-confirmation/exit-confirmation.component";
import { QuestionnaireComponent } from "./questionnaire/questionnaire.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { CardReaderComponent } from "./card-reader/card-reader.component";

const routes: Routes = [
  { path: "booking", component: BookingNavComponent },
  { path: "exit-confirmation", component: ExitConfirmationComponent },
  { path: "questionnaire/:code", component: QuestionnaireComponent }, // AR-24 patient questionnaire (must stay ABOVE :key)
  { path: "checkin/:key", component: CardReaderComponent }, // Kiosk: Macabi card-swipe self check-in (must stay ABOVE :key)
  { path: "welcome/:key", component: WelcomeComponent }, // Kiosk: type-TZ self check-in (must stay ABOVE :key)
  { path: "w/:key", component: AppointmentsSetupNavComponent }, // WhatsApp
  { path: "c/:key", component: AppointmentsSetupNavComponent }, // Clinic website
  { path: ":key", component: AppointmentsSetupNavComponent }, // Default
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
